import { render, staticRenderFns } from "./AwsVideo.vue?vue&type=template&id=70924072&"
import script from "./AwsVideo.vue?vue&type=script&lang=js&"
export * from "./AwsVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports